<template>
  <div class="">
    <div
      v-for="item in newsList"
      :key="item.id"
      class="text-left border-b py-8"
    >
      <p class="text-base">{{ item.title }}</p>
      <p class="text-sm text-gray-500">
        {{ delHtmlTag(item.content) }}
      </p>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="newsListTotal"
      :page-size="8"
      @current-change="handleCurrentChange"
      :hide-on-single-page="true"
      class="mt-5"
    ></el-pagination>
  </div>
</template>
<script>
import { onMounted, ref, watch } from "@vue/composition-api";

export default {
  setup(props, ctx) {
    const current_tag = ref();
    const newsList = ref();
    const newsListTotal = ref();
    const getNewsList = async (...args) => {
      const res = await ctx.root.$callapi("news/getNewsList", {
        page: args[0],
        size: 8,
        tag: args[1],
      });

      newsList.value = res.data.items;
      newsListTotal.value = res.data.total;
    };
    watch(
      () => ctx.root.$route.query.tag,
      () => {
        current_tag.value = ctx.root.$route.query.tag;
        getNewsList(1, current_tag.value);
      }
    );
    const handleCurrentChange = (val) => {
      getNewsList(val, current_tag.value);
    };
    onMounted(() => {
      getNewsList(1, ctx.root.$route.query.tag);
    });
    //去除html 标签
    const delHtmlTag = (str) => {
      return str.replace(/<[^>]+>/g, "");
    };

    return {
      current_tag,
      newsList,
      handleCurrentChange,
      newsListTotal,
      delHtmlTag,
    };
  },
};
</script>
<style scoped lang="scss"></style>